import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { BY_PART } from '../../config/modularized.config';
import { ModelVisualizatorBuilder } from '../../models/builders/model-visualizator.builder';
import { getServerDateDiff } from '../../utils/response.utils';

@Injectable()
export class ModelVisualizatorApiService {
  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = `${environment.apiUrl}model-visualizators`;
  }

  getModelVisualizators(models: any) {
    let params = new HttpParams();
    if (models && environment.visualizatorModularized === BY_PART) {
      for (const model of models) {
        params = params.append('models', model.hash);
      }
    }
    return this.httpClient.get(`${this.apiUrl}`, { observe: 'response', params: params }).pipe(
      map(resp => ModelVisualizatorBuilder.modelVisualizatorFromList(resp.body, getServerDateDiff(resp)))
    );
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/model-visualizator-api.service.ts